import React, { Fragment, useState } from 'react';
import { SelectFilter } from 'tradera-apps/tradera/components/discover/components/filters/select-filter';
import RadioSwitch from 'tradera-components/form-controls/radio-switch';
import { useTranslator } from 'tradera-lang/translate';

const FilterShipTo = ({
    allowedBuyerRegions,
    county,
    handleFilterChange,
    queryParams,
    allowedBuyerRegionFilterEnabled
}) => {
    const { t } = useTranslator();
    const allowedBuyerRegionToggleOptions = [
        { name: t('searchFilters_shipTo_buyerRegion'), value: 'buyerRegion' },
        { name: t('searchFilters_shipTo_pickUp'), value: 'pickUp' }
    ];
    const [selectedUI, setSelectedUI] = useState(queryParams.county ? 1 : 0);
    const buyerRegionElements = (
        <SelectFilter
            filter={allowedBuyerRegions}
            handleFilterChange={handleFilterChange}
            id="filter-allowedBuyerRegion"
            selectClassName="form-control-sm"
        />
    );
    const countyElements = (
        <SelectFilter
            filter={county}
            handleFilterChange={handleFilterChange}
            id="filter-countyBox"
            selectClassName="form-control-sm"
        />
    );
    const handleToggleChange = () => {
        const currentFilter = selectedUI === 0 ? allowedBuyerRegions : county;
        handleFilterChange(currentFilter.parameter, null);
        setSelectedUI((selectedUI + 1) % 2);
    };
    const combinedUI = () => (
        <Fragment>
            <div className="col-12 p-0">
                <RadioSwitch
                    id="filter-allowedBuyerRegionToggle"
                    options={allowedBuyerRegionToggleOptions}
                    checked={allowedBuyerRegionToggleOptions[selectedUI].value}
                    handleOnChange={handleToggleChange}
                    className="form-control-radio-switch-sm"
                />
            </div>
            <hr />
            {selectedUI === 0 ? buyerRegionElements : countyElements}
        </Fragment>
    );
    return allowedBuyerRegionFilterEnabled ? combinedUI() : countyElements;
};

export default FilterShipTo;
